import {Sensor, SensorUpdateRequest} from "../../../../api/sensor";
import {Dialog, DialogClose, DialogContent, DialogOptions} from "../../../generic/dialog";
import {WithAPI} from "../../../../api/temperature";
import {useLoader} from "../../../generic/loader";
import {Card} from "../../../generic/card";
import {FormFooter, FormGroup} from "../../../generic/form";
import {Button} from "../../../generic/button";
import {useFlash} from "../../../generic/flash";

type SensorDialogProps = {
    sensor: Sensor;
    onSubmit: (sensor: SensorUpdateRequest) => boolean | Promise<boolean>;
} & DialogOptions;

function SensorDialog({sensor, onSubmit, ...props}: SensorDialogProps) {
    const createSensor = (form: HTMLFormElement): SensorUpdateRequest => {
        const fd = new FormData(form);

        return {
            id: sensor.id,
            name: fd.get("name") as string
        };
    }

    return <Dialog {...props}>
        <DialogContent>
            <Card title={sensor.name}>
                <form onSubmit={(e) => {
                    const sensor = createSensor(e.currentTarget);
                    if (sensor) {
                        const res = onSubmit(sensor);
                        if (res instanceof Promise) {
                            res.then((res: boolean) => {
                                if (res) {
                                    props.onOpenChange(false);
                                }
                            });
                        } else if (res) {
                            props.onOpenChange(false);
                        }
                    }

                    e.preventDefault();
                }}>
                    <FormGroup>
                        <label for="input--sensor-name">Name:</label>
                        <input type="text" name="name" id="input--sensor-name" value={sensor.name}/>
                    </FormGroup>

                    <FormFooter>
                        <Button type="submit">Modify</Button>
                        <DialogClose>Cancel</DialogClose>
                    </FormFooter>
                </form>
            </Card>
        </DialogContent>
    </Dialog>
}

export function ModifySensor({api, sensor, ...props}: WithAPI & DialogOptions & { sensor: Sensor }) {
    const [showLoader, hideLoader] = useLoader();
    const {success} = useFlash();

    return <SensorDialog sensor={sensor} {...props} onSubmit={async (sensor: SensorUpdateRequest) => {
        showLoader("Saving...");
        try {
            await api.sensor.update(sensor);
            success(`Sensor ${sensor.name} has been updated.`);
            return true;
        } finally {
            hideLoader();
        }

        return false;
    }}/>;
}
